/** @jsxImportSource @emotion/react */

import { Position, Tag, Tooltip } from "@blueprintjs/core"

import { exposeFirstXStringFromList } from "../../../../utils"
import {
  SideTickerBlockContainer,
  SideTickerItem,
  TagContainer,
  tagCss,
  TickerListContainer,
  TickerListText,
} from "./WaveTickerList.styled"
import { OrderStatus, Side } from "./types/common"
import { Order } from "./types/order"

interface IWaveOrdersProps {
  orders: Order[]
}

const WaveTickerList = ({ orders }: IWaveOrdersProps) => {
  return (
    <TickerListContainer
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      gap="6px"
    >
      <SideTickerBlock sides={[Side.BUY, Side.BUY_COVER]} orders={orders} />
      <SideTickerBlock sides={[Side.SELL, Side.SELL_SHORT]} orders={orders} />
    </TickerListContainer>
  )
}

const SideTickerBlock = ({ sides, orders }: { sides: Side[]; orders: Order[] }) => (
  <SideTickerBlockContainer>
    {sides.map(
      side =>
        orders.some(order => order.side === side) && (
          <SideTickerItem key={side}>
            <TagContainer>
              <Tag minimal css={tagCss({ side })}>
                {side.replace("_", " ").toUpperCase()}
              </Tag>
            </TagContainer>
            <Tooltip
              compact
              minimal
              position={Position.BOTTOM}
              disabled={orders.filter(order => order.side === side).length <= 3}
              content={orders
                .filter(order => order.side === side)
                .map(order => order.instrument?.bloomberg_code?.replace(" Equity", ""))
                .join(", ")}
            >
              <TickerListText>
                {exposeFirstXStringFromList(
                  orders
                    .filter(order => order.side === side)
                    .filter(
                      order =>
                        order.status &&
                        ![
                          OrderStatus.CANCELLED_FOR_REPLACEMENT,
                          OrderStatus.BEING_REPLACED,
                          OrderStatus.REPLACE_FAILED,
                        ].includes(order.status),
                    )
                    .map(order => order.instrument?.bloomberg_code?.replace(" Equity", "")),
                  // Limit to 2 items per line to avoid wrapping
                  2,
                )}
              </TickerListText>
            </Tooltip>
          </SideTickerItem>
        ),
    )}
  </SideTickerBlockContainer>
)

export default WaveTickerList
